import { ITaskManagerServer } from '../../../../../../../service/taskManager/server/ITaskManagerServer';
import { ITaskManagerServerService } from '../../../../../../../service/taskManager/server/ITaskManagerServerService';
import { IRowContextMenuUI } from '../../../../../../design/dataTable/parts/rowContextMenu/domain/IRowContextMenuUI';
import { RowContextMenuDomain } from '../../../../../../design/dataTable/parts/rowContextMenu/domain/RowContextMenuDomain';
import { IDataTableDomain } from '../../../../../../design/dataTable/store/IDataTableDomain';
import { IMainLayoutDomainStore } from '../../../../../../layout/main/store/domain/IMainLayoutDomainStore';
import { TaskManagerAdminContextMenuUI } from './TaskManagerAdminContextMenuUI';

export class TaskManagerAdminContextMenuDomain extends RowContextMenuDomain<ITaskManagerServer> {
  constructor({
    entityService,
    dataTableDomain,
    layoutDomain,
    ui,
  }: {
    entityService: ITaskManagerServerService;
    dataTableDomain: IDataTableDomain<ITaskManagerServer, any>;
    layoutDomain: IMainLayoutDomainStore;
    ui?: IRowContextMenuUI<ITaskManagerServer> | null;
  }) {
    super(entityService, dataTableDomain, layoutDomain, ui);
    this.ui = ui || new TaskManagerAdminContextMenuUI(this);
  }
}
